import React, { ReactElement, useMemo } from "react";
import { Fetcher } from "@costar-search-x/core";
import { Grid } from "@costar/theme-ui";
import { supportedLocationTypes } from "../../shared/constants";
import { LocationSearchRequest } from "@/external-services/types";
import { ConnectedProps } from "../../shared/filters/types";
import { FilterModal } from "../../shared/filters/FilterModal";
import { Resources } from "@/app/i18n/src";
import { LocationFilter } from "./components/location-filter";
import { LocationSecteurFilter } from "./components/secteur-filter";
import { cn } from "@costar-ui/cosmos";

//TODO: Fix these once the filters are finalized
export type MasterToolbarFiltersProps = {
  companyTypeaheadFetcher: Fetcher<[term: string], any | undefined>;
  locationTypeaheadFetcher: Fetcher<
    [placeId: string, matchTypes: number[], type?: string],
    any | undefined
  >;
  fetchPlaceDetail: Fetcher<[placeId: string], any | undefined>;
  isDesktop: boolean;
  expandToolbar: boolean;
  onFilterIconClick: (e: any) => void;
  onClearFiltersButton?: () => void;
  resources: Resources;
  isAuthenticated?: boolean;
} & ConnectedProps<LocationSearchRequest>;

const automationIdPrefix = "sites-search-master-toolbar";

export const MasterToolbarFiltersUi = (
  props: MasterToolbarFiltersProps
): ReactElement => {
  const {
    criteria,
    updateCriteria,
    locationTypeaheadFetcher,
    fetchPlaceDetail,
    isDesktop,
    expandToolbar,
    onFilterIconClick,
    onClearFiltersButton,
    resources,
    isAuthenticated,
  } = props;

  const locationMessages = useMemo(
    () => ({
      inputPlaceholderText:
        resources?.filters.location.sites.typeahead.subtitle(),
      placeholderRenderTitle: resources?.filters.location.typeahead.subtitle(),
      noResults: resources?.filters.companyName.typeahead.noResults(),
      loading: resources?.filters.companyName.typeahead.loading(),
    }),
    [resources?.filters.companyName, resources?.filters.location]
  );

  // temp
  // const secteurFilterMessages = useMemo(
  //   () => ({
  //     inputPlaceholderText: resources?.filters.specialite.title(),
  //     loading: resources?.filters.companyName.typeahead.loading(),
  //   }),
  //   [resources?.filters]
  // );

  const filterMessages = useMemo(
    () => ({
      clearButtonLabel: resources?.clearButtonLabel() || "",
      doneButtonLabel: resources?.doneButtonLabel() || "",
    }),
    [resources]
  );

  const filters = useMemo(
    () => [
      <LocationFilter
        automation-id={`${automationIdPrefix}-location`}
        criteria={criteria}
        updateCriteria={updateCriteria}
        getOptions={locationTypeaheadFetcher}
        matchTypes={supportedLocationTypes}
        placeDetailFetcher={fetchPlaceDetail}
        messages={locationMessages}
        key="location-filter"
      />,
      // temp
      // <LocationSecteurFilter
      //   messages={secteurFilterMessages}
      //   criteria={criteria}
      //   updateCriteria={updateCriteria}
      //   automation-id={`${automationIdPrefix}-secteur-filter`}
      //   key="specialty-filter"
      // />,
    ],
    [
      criteria,
      fetchPlaceDetail,
      locationMessages,
      locationTypeaheadFetcher,
      // temp
      // secteurFilterMessages,
      updateCriteria,
    ]
  );

  return isDesktop ? (
    <Grid
      id="filter-section"
      automation-id="filter-bar"
      gap="xs"
      width="100%"
      // temp
      // gridTemplateColumns="minmax(150px, 290px) minmax(200px, 270px)"
      gridTemplateColumns="minmax(150px, 290px)"
      alignItems="center"
      className={cn("", {
        "pointer-events-none": !isAuthenticated,
      })}
    >
      {filters}
    </Grid>
  ) : (
    <FilterModal
      expandToolbar={expandToolbar}
      onFilterIconClick={onFilterIconClick}
      onClearFiltersButton={onClearFiltersButton}
      isDesktop={isDesktop}
      filterMessages={filterMessages}
    >
      {filters}
    </FilterModal>
  );
};

MasterToolbarFiltersUi.displayName = "SitesMasterToolbarFiltersUI";
